/* Model */
class PaymentMethodAllowedModel extends App.Models.BaseModel {
  modelUrl = 'PaymentMethodAllowed';
}

App.Models.PaymentMethodAllowed = PaymentMethodAllowedModel;

/* Collection */
class PaymentMethodAllowedCollection extends App.Collections.BaseCollection {
  url = 'PaymentMethodAllowed';
  model = App.Models.PaymentMethodAllowed;
}

App.Collections.PaymentMethodAlloweds = PaymentMethodAllowedCollection;

/* Router */
class PaymentMethodAllowedRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'PaymentMethodAllowed';
      const model = App.Models.PaymentMethodAllowed;
      const collectionClass = App.Collections.PaymentMethodAlloweds;

      super(entityName, model, collectionClass);
  }
}

App.Routers.PaymentMethodAllowed = PaymentMethodAllowedRouter;